export default {
  SET_TRANSACCIONALITY(state, payload) {
    state.transaccionality = payload;
  },
  SET_HOLDING_TRANSACCIONALITY(state, payload) {
    state.holdingTransaccionality = payload;
  },
  SET_TRANSACTIONALITY_PAGINATION(state, payload) {
    state.transactionalityPagination = payload;
  }
};
